module.exports = __webpack_public_path__ + "img/hr-cliff-sides-shadow.74122f98.png";